import { render } from "./org-support-cases-list.vue?vue&type=template&id=636d6546"
import script from "./org-support-cases-list.vue?vue&type=script&lang=js"
export * from "./org-support-cases-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__